import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'user';

const userService = {
  getUserByPinCode: (pinCode) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/user/${encodeURIComponent(pinCode)}`,
    });
  },

  getUsers: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/users`,
      data,
    });
  },

  createUser: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateUser: (data, userId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(userId)}`,
      data,
    });
  },

  deleteUser: (data, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(userId)}`,
      data,
    });
  },

  updatePassword: (data, userId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/updatePassword/${encodeURIComponent(userId)}`,
      data,
    });
  },
};

export default userService;
